import React, { useCallback, useMemo, useState } from 'react';
import { COUNTRY_SELECTOR_DEFAULT } from './orderlist.enums';
import { useCountries } from '../../../hooks/useCountries';
export interface CommissionStatus {
  id: string;
  label: string;
}

const useTrackTableColumnsWidth = (tableRef:  React.RefObject<{tableContainerDiv?: any} | null>) => {
  const [columnWidths, setColumnWidths] = useState<Array<number>>([])

  const getColumnWidths = useCallback(() => {
    const container = tableRef?.current?.tableContainerDiv?.current;
    if (!container) return [];
    const headerCells = container.querySelectorAll('[data-header-cell]');
    if (!headerCells || headerCells.length === 0) return [];
    return [...headerCells].map((cell: any) => cell.offsetWidth);
  }, [tableRef])

  const updateColumnWidth = useCallback(() => {
    Promise.resolve().then(() => setColumnWidths(getColumnWidths()));
  }, [getColumnWidths]);

  return {columnWidths, updateColumnWidth}
}

const useCountrySelector = () => {
  const [selectedCountry, setSelectedCountry] = useState(COUNTRY_SELECTOR_DEFAULT);
  const { countries } = useCountries();
  const options = [
    { value: COUNTRY_SELECTOR_DEFAULT, id: 'null' },
    ...countries.map((country)=>({
      value: country.countryName, id: country.countryIso
    })),
  ];

  const onCountrySelect = useCallback((event: any) => {
    setSelectedCountry(event.target.value || COUNTRY_SELECTOR_DEFAULT);
  }, [setSelectedCountry])

  const countrySelector = useMemo(() => ({
    label: '',
    value: selectedCountry,
    options,
    onChange: onCountrySelect,
    width: '160px'
  }), [selectedCountry, options, onCountrySelect]);

  return { selectedCountry, countrySelector }
}

const useCommissionStatusSelector = (
  value: string,
  onChange: (next: string) => void,
  statuses: CommissionStatus[]
) => {
  const options = useMemo(
    () => statuses.map(s => ({ value: s.label, id: s.id })),
    [statuses]
  );

  const handleChange = useCallback((event: any) => {
    const match = options.find(o => o.value === event.target.value);
    if (match) onChange(match.id);
  }, [onChange, options]);

  const commissionStatusSelector = useMemo(() => ({
    label: 'Commission Status',
    value: statuses.find(s => s.id === value)?.label || value,
    options,
    onChange: handleChange,
    width: '160px'
  }), [value, statuses, options, handleChange]);

  return { commissionStatusSelector };
};

export { useTrackTableColumnsWidth, useCountrySelector, useCommissionStatusSelector }